import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const firstString = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return '';
  return String(arr[0] || '').trim();
};

/**
 * Transforms facebook_brand_page criteria.
 * Minimal output: Name + URL.
 *
 * @param {Object} facebookBrandPageCriteria - criteria.facebook_brand_page
 * @returns {Object} transformed criteria
 */
export const transformFacebookPage = (facebookBrandPageCriteria) => {
  if (!facebookBrandPageCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Facebook Page was found.',
      data: null,
    };
  }

  const wooRankStatus = facebookBrandPageCriteria?.status || 'neutral';
  const importance = facebookBrandPageCriteria?.importance || 0;
  const solvability = facebookBrandPageCriteria?.solvability || 0;

  const name = String(facebookBrandPageCriteria?.data?.name || '').trim();
  const url = String(facebookBrandPageCriteria?.data?.pageUrl || '').trim() || firstString(facebookBrandPageCriteria?.data?.urls);

  const isEmpty = !name && !url;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Facebook Page was found.' : null,
    data: isEmpty ? null : { name, url },
  };
};

export default transformFacebookPage;


